import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { SharedModule } from "../shared/shared.module";

import { ChangePasswordDialogComponent } from "./change-password-dialog/change-password-dialog.component";
import { AuthGuard } from "./auth-guard.service";
import { AuthService } from "./auth.service";
import { UnauthRedirectInterceptor } from "./unauth-redirect.interceptor";

@NgModule({
    imports: [
        SharedModule,
    ],

    declarations: [
        ChangePasswordDialogComponent,
    ],

    exports: [
        ChangePasswordDialogComponent,
    ],

    entryComponents: [
        ChangePasswordDialogComponent
    ],

    providers: [
        AuthGuard,
        AuthService,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthRedirectInterceptor,
            multi: true
        }
    ]
})
export class AuthModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/auth/auth.module.ts